import React from 'react'
import ContactUsLeft from '../../components/ContactUsLeft'
import { useRouteError } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import NotFoundSec from '../pageNotFound/NotFoundSec';
import { t } from 'i18next';
import { encodeId, slugify } from '../../helper/helperFunction';
import CustomImageComponent from '../../components/CustomImageComponent';
import { useCountryPrefix } from '../../routes/useCountryPrefix';


const AreaSec = (props) => {
    const { areaData, areaName } = props
    const { i18n } = useTranslation();
    const countryPrefix = useCountryPrefix();



    const language = i18n.language === "en" ? "" : i18n.language || "";


    const offer = areaData?.offers
    const developerProjects = areaData?.developers
    const contactDetails = areaData?.contactDetails

    return (
        <>
            {developerProjects?.length > 0 ? (
                <section className="details-slider-section mt-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-8 left-content">



                                {offer?.length > 0 ? (
                                    <>
                                        <div className="property-view-section">
                                            <h2 className="title">{t("offer")}</h2>
                                        </div>
                                        <div className="row mb-5">

                                            {offer?.length &&
                                                offer?.map((item, index) => (

                                                    <div className="col-md-4" key={index} >
                                                        <div className="offer-card">
                                                            <div className="white-box">
                                                                <h2>{item.title}</h2>
                                                                <h6>{item.developerName}</h6>
                                                                <p className="pb-0">{item.projectName}</p>
                                                            </div>
                                                            <div className="d-flex mt-3 justify-content-between align-items-center offer-blk-wrapper">
                                                                <div className="offer-blk">
                                                                    <h6 className="fw-bold">{t("get_offer")}</h6>
                                                                    <p className="pb-0 small">{t("and_know_more")}</p>
                                                                </div>

                                                                <div className="right-block w-100">
                                                                    <div>
                                                                        {/* <a className="call-btn" href={`tel:${contactDetails.phone}`}>
                                                                                <CustomImageComponent src={"/assets/img/icon-call.svg"} alt={"Phone"} /> {t("call_us")}
                                                                            </a> */}
                                                                        <a className="call-btn whatsapp-btn" href={`https://wa.me/${contactDetails.whatsApp}`} target="_blank" rel="noopener noreferrer">
                                                                            <CustomImageComponent src={"/assets/img/icon-whatsapp.svg"} alt={"WhatsApp"} /> {t("whatsapp")}
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}

                                        </div>
                                    </>
                                ) : ""

                                }


                                <section className="company-info-section developer-list-section">
                                    <div className="container">
                                        {developerProjects?.length &&
                                            developerProjects?.map((item, index) => (
                                                <div className="company-info-wrapper" key={index}>
                                                    <div className="row align-items-center">
                                                        <div className="col-md-12 col-lg-3">
                                                            <div className="img-block p-2">
                                                                <CustomImageComponent src={item.developerDetails.thumbnailImage} alt={item.developerDetails.developerName} className={"img-fluid"} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 col-lg-9 ">
                                                            <div className="right-part">
                                                                <div className="top-block">
                                                                    <div className="left-block">
                                                                        <div className="content-block">
                                                                            <h5>{item.developerDetails.developerName || 'N/A'}</h5>
                                                                            <h5><span>{item.developerDetails.projectCount} {t("project_available")}</span><span>{item.developerDetails.propertyCount} {t("properties_available")}</span></h5>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                                <p>{item.developerDetails.description || 'N/A'}</p>

                                                                <div className="text-end pb-3">
                                                                    {/* <a className="view-more" href={`${language === 'ar' ? `/${language}` : ''}/developer/${item.developerDetails.developerId}`} */}
                                                                    <a className="view-more" href={`/${countryPrefix}${language ? `/${language}` : ''}/developers/${slugify(areaName)}/${slugify(item.developerDetails.developerName)}/${encodeId(item.developerDetails.developerId)}`}
                                                                    >{t("view_more")} <i className="fa-solid fa-chevron-right"></i></a>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                </section>





                            </div>
                            <div className="col-md-4 right-content">
                                <div className="contact-section inquiry-form-right ">
                                    <ContactUsLeft></ContactUsLeft>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >
            ) : (<NotFoundSec title={t("opps")} desc={t("property_not_found")} cssstyle={"pt-5"} img={"/assets/img/not-found.svg"} />)

            }
        </>
    )
}

export default AreaSec